import {
    HeadphonesRounded,
    ImageRounded,
    MicRounded,
    SmartDisplayRounded,
} from '@mui/icons-material';
import { Box, Tab, Tabs } from '@mui/material';
import * as React from 'react';
import FragmentMinisterFAB from '../../components/fragments/FragmentMinisterFAB';
import Crusades from './sections/Crusades';
import Devotions from './sections/Devotions';
import Posts from './sections/Posts';
import Videos from './sections/Videos';

export default function FragmentOnlinePastor() {
    const [value, setValue] = React.useState(0);

    const handleChange = (_, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ my: 2 }} className="w-100">
            <Tabs
                value={value}
                onChange={handleChange}
                aria-label="icon tabs example"
                variant="scrollable"
                scrollButtons="auto"
            >
                <Tab
                    sx={{ minWidth: window.innerWidth / 4 }}
                    icon={<SmartDisplayRounded />}
                    wrapped
                />
                <Tab
                    sx={{ minWidth: window.innerWidth / 4 }}
                    icon={<HeadphonesRounded />}
                    wrapped
                />
                <Tab
                    sx={{ minWidth: window.innerWidth / 4 }}
                    icon={<MicRounded />}
                    wrapped
                />
                <Tab
                    sx={{ minWidth: window.innerWidth / 4 }}
                    icon={<ImageRounded />}
                    wrapped
                />
            </Tabs>
            {value === 0 && <Videos />}
            {value === 1 && <Devotions />}
            {value === 2 && <Crusades />}
            {value === 3 && <Posts />}
            <FragmentMinisterFAB />
        </Box>
    );
}
